import React from 'react'
import services from 'core/services'

/**
 * Parse styles and apply theme and direction setting
 * @param {Object} styles styles to parse
 * @return {Object} parsed styles
 */
function parseStyles(styles = {}, dir = 'ltr', theme = 'light') {
  let parsedStyles = {}

  for (const className in styles) {
    if (styles.hasOwnProperty(className)) {
      if (dir === 'rtl' && /^rtl_.*/.test(className)) {
        Object.assign(parsedStyles, {
          [className.replace('rtl_', '')]: styles[className]
        })

        continue
      }

      if (!parsedStyles.hasOwnProperty(className)) {
        Object.assign(parsedStyles, { [className]: styles[className] })
      }
    }
  }

  return parsedStyles
}

export default (styles = {}) => {
  return Component => props => (
    <Component
      {...props}
      classes={parseStyles(styles, services.translation.dir())}
    />
  )
}
